<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <b-card>
          <div slot="header">
            <strong>{{$t('NEWACLOBJECT')}}</strong>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('OBJECTNAME')">
                <inputvalidation :formerror="formError" name="objectName"><b-form-input type="text" v-model="formData.objectName" v-bind:placeholder="$t('OBJECTNAME')"></b-form-input></inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('OBJECTFUNCTION')">
                <b-form-input type="text" v-model="formData.objectFunction" v-bind:placeholder="$t('OBJECTFUNCTION')"></b-form-input>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('OBJECTDESCRIPTION')">
                <b-form-textarea type="text" v-model="formData.objectDescription" v-bind:placeholder="$t('OBJECTDESCRIPTION')"></b-form-textarea>
              </b-form-fieldset>
            </div>
          </div>
          <div slot="footer">
            <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
            <b-button type="submit" size="sm" variant="primary" v-on:click.prevent="saveAcl"><i class="fa fa-dot-circle-o"></i> {{$t('SUBMIT')}}</b-button>
          </div>
        </b-card>
      </div><!--/.col-->
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
              <i class="fa fa-align-justify"></i> {{$t('ACLOBJECTS')}}
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('GROUP')">
                    <b-form-select :options="aclGroups.root" v-model="searchGroupId" value-field="groupId" text-field="groupName"></b-form-select>
                  </b-form-fieldset>
                </div>
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('SEARCH')">
                    <b-form-input v-model="pagination.query"></b-form-input>
                  </b-form-fieldset>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="typeof acl.root == 'undefined' || !acl.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="card-body" v-if="typeof acl.root != 'undefined' && acl.root.length">
              <table class="table table-responsive-sm table-striped">
                <thead>
                  <tr>
                    <th>{{$t('ID')}}</th>
                    <th>{{$t('OBJECTNAME')}}</th>
                    <th>{{$t('OBJECTFUNCTION')}}</th>
                    <th>{{$t('INSERTPRIVILAGE')}}</th>
                    <th>{{$t('UPDATEPRIVILAGE')}}</th>
                    <th>{{$t('DELETEPRIVILAGE')}}</th>
                    <th>{{$t('INSTANTIATE')}}</th>
                    <th>{{$t('OWNERHANDLING')}}</th>
                    <th>{{$t('COMPANYHANDLING')}}</th>
                    <th>{{$t('DELETE')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="priv in acl.root">
                    <td>{{priv.objectId}}</td>
                    <td>{{priv.objectName}}</td>
                    <td>{{priv.objectFunction}}</td>
                    <td><c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.insertPrivilage == 1) ? true : false" v-on:change="setAcl(priv, 'insertPrivilage')"/></td>
                    <td><c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.updatePrivilage == 1) ? true : false" v-on:change="setAcl(priv, 'updatePrivilage')"/></td>
                    <td><c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.deletePrivilage == 1) ? true : false" v-on:change="setAcl(priv, 'deletePrivilage')"/></td>
                    <td><c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.instantiate == 1) ? true : false" v-on:change="setAcl(priv, 'instantiate')"/></td>
                    <td><c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.ownerAction == 1) ? true : false" v-on:change="setAcl(priv, 'ownerAction')"/></td>
                    <td><c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.companyAction == 1) ? true : false" v-on:change="setAcl(priv, 'companyAction')"/></td>
                    <td><b-button type="reset" size="sm" variant="danger" v-on:click.prevent="deleteAcl(priv.objectId)"><i class="fa fa-ban"></i> {{$t('DELETE')}}</b-button></td>
                  </tr>
                </tbody>
              </table>
              <nav>
                <b-pagination align="center" :total-rows="parseInt(acl.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
              </nav>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import cSwitch from '../../components/lib/Switch'
import { mapActions, mapGetters } from 'vuex'
import AclApi from '@/api/admin/Acl'
import AclGroupsApi from '@/api/admin/AclGroups'

export default {
  name: 'Acl',
  components: {
    cSwitch
  },
  data: function()
  {
    return {
      acl: {},
      aclGroups: {},
      formData: {
        id: '',
        objectName: '',
        objectFunction: '',
        objectDescription: ''
      },
      formError: {},
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 20,
        searchTimeout: false
      },
      searchGroupId: 2
    }
  },
  created: function()
  {
    var me = this;
    me.getAcl();
    me.getAclGroups();
  },
  methods:
  {
    saveAcl: function()
    {
      var me = this;

      AclApi.saveAcl(me.formData, function(val)
      {
        if(val.error)
        {
          me.formError = val;
        }
        else
        {
          me.formError = {};
          me.formData = {
            id: '',
            objectName: '',
            objectFunction: '',
            objectDescription: ''
          };
          me.getAcl();
        }
      })
    },
    setAcl(priv, type)
    {
      var me = this;
      priv[type] = (priv[type] == 0) ? 1 : 0;
      priv.groupId = me.searchGroupId;
      AclApi.updatePrivilageByGroupId(priv, function(val)
      {
        if(val.error)
        {
          me.$notify.error(val.notice);
        }

        me.getAcl();
      })
    },
    getAcl: function()
    {
      var me = this;
      AclApi.getPrivilagesByGroupId(me.getParams, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }
        me.acl = data;
      });
    },
    getAclGroups: function()
    {
      var me = this;
      AclGroupsApi.selectRow(me.getGroupParams, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }
        me.aclGroups = data;
      });
    },
    deleteAcl: function(id)
    {
      var me = this;
      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          AclApi.deleteAcl({id: id}, function(data)
          {
            if(data.error && data.error == true) me.$notify.error(data.notice);
            else me.$notify.success(data.notice);
            me.getAcl();
          })
        }
      })
    }
  },
  watch:
  {
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getAcl();
    },
    'pagination.query': function(val)
    {
      var me = this;

      if(me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getAcl();
        me.pagination.searchTimeout = false;
      }, 300);
    },
    searchGroupId()
    {
      var me = this;
      me.getAcl();
    }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      data.groupId = me.searchGroupId;
      return data;
    },
    getGroupParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      return data;
    }
  }
}
</script>
